import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import EnrollmentTable from '@activities/components/tables/enrollment-table/enrollment-table.vue';
import EnrollmentTabs from '@activities/components/tabs/enrollment/enrollment-tabs.vue';
import BpcPageTitle from '@shared/layouts/components/page-title/page-title.vue';

@Component({
  name: 'bpc-enrollment',
  components: {
    'bpc-enrollment-table': EnrollmentTable,
    'bpc-enrollment-tabs': EnrollmentTabs,
    'bpc-page-title': BpcPageTitle,
  },
})
export default class EnrollmentWrapper extends Vue {
  /* Lifecycle hooks */
  // created() {}
  // mounted() {}
  // updated() {}
  // destroyed() {}
}
